/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n';
/**
 * Internal dependencies
 */

import edit from './edit';
import icon from './icon';
var metadata = {
  name: "core/nextpage",
  category: "layout"
};
import save from './save';
import transforms from './transforms';
var name = metadata.name;
export { metadata, name };
export var settings = {
  title: __('Page Break'),
  description: __('Separate your content into a multi-page experience.'),
  icon: icon,
  keywords: [__('next page'), __('pagination')],
  supports: {
    customClassName: false,
    className: false,
    html: false
  },
  example: {},
  transforms: transforms,
  edit: edit,
  save: save
};
//# sourceMappingURL=index.js.map